export const namespaced = true;

const initState = () => ({
  sessions: [],
  pagination: { total: 0, page: 1, limit: 20, totalPages: 0 },
  isLoading: false,
  isStatusLoading: false,
  error: null,
  coachSlots: null,
  isSlotsLoading: false,
  filterOptions: { organizations: [], programs: [], coaches: [] },
  isFilterOptionsLoading: false,
});

export const state = initState();

export const mutations = {
  SET_SESSIONS(state, sessions) {
    state.sessions = sessions;
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = { ...pagination };
  },
  SET_LOADING(state, val) {
    state.isLoading = val;
  },
  SET_STATUS_LOADING(state, val) {
    state.isStatusLoading = val;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_COACH_SLOTS(state, slots) {
    state.coachSlots = slots;
  },
  SET_SLOTS_LOADING(state, val) {
    state.isSlotsLoading = val;
  },
  SET_FILTER_OPTIONS(state, options) {
    state.filterOptions = options;
  },
  SET_FILTER_OPTIONS_LOADING(state, val) {
    state.isFilterOptionsLoading = val;
  },
  CLEAN_STATE(state) {
    Object.assign(state, initState());
  },
};

export const actions = {
  cleanState({ commit }) {
    commit("CLEAN_STATE");
  },

  async fetchSysadminSessions({ commit }, params) {
    try {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      const restClient = require("../../lib/restClient").default;
      const { data } = await restClient.get("/api/v1/sessions", { params });
      commit("SET_SESSIONS", data.sessions);
      commit("SET_PAGINATION", data.pagination);
      return data;
    } catch (error) {
      commit("SET_ERROR", error?.response?.data?.error || "UNKNOWN_ERROR");
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async forceRescheduleSession({ commit }, { sessionId, slot, reason }) {
    try {
      commit("SET_SLOTS_LOADING", true);
      const restClient = require("../../lib/restClient").default;
      const result = await restClient.patch(`/api/v1/sessions/${sessionId}/slot`, {
        slot,
        ...(reason ? { reason } : {}),
      });
      return result.data;
    } catch (error) {
      throw error;
    } finally {
      commit("SET_SLOTS_LOADING", false);
    }
  },

  async fetchSessionFilterOptions({ commit }) {
    try {
      commit("SET_FILTER_OPTIONS_LOADING", true);
      const restClient = require("../../lib/restClient").default;
      const [orgsResult, programsResult, coachesResult] = await Promise.allSettled([
        restClient.get("/api/v1/organizations", { params: { includeMembershipData: false } }),
        restClient.get("/api/v1/programs"),
        restClient.get("/api/v1/users/coaches"),
      ]);
      commit("SET_FILTER_OPTIONS", {
        organizations: orgsResult.status === "fulfilled" ? (orgsResult.value.data.organizations ?? []) : [],
        programs: programsResult.status === "fulfilled" ? (programsResult.value.data ?? []) : [],
        coaches: coachesResult.status === "fulfilled" ? (coachesResult.value.data ?? []) : [],
      });
    } finally {
      commit("SET_FILTER_OPTIONS_LOADING", false);
    }
  },

  async updateSysadminSessionStatus({ commit }, { sessionId, state, reason }) {
    try {
      commit("SET_STATUS_LOADING", true);
      const restClient = require("../../lib/restClient").default;
      const result = await restClient.patch(`/api/v1/sessions/${sessionId}/status`, {
        state,
        ...(reason ? { reason } : {}),
      });
      return result.data;
    } catch (error) {
      throw error;
    } finally {
      commit("SET_STATUS_LOADING", false);
    }
  },
};

export const getters = {
  getSessions: (state) => state.sessions,
  getPagination: (state) => state.pagination,
  isLoading: (state) => state.isLoading,
  isStatusLoading: (state) => state.isStatusLoading,
  getCoachSlots: (state) => state.coachSlots,
  isSlotsLoading: (state) => state.isSlotsLoading,
  getFilterOptions: (state) => state.filterOptions,
  isFilterOptionsLoading: (state) => state.isFilterOptionsLoading,
};
